/* eslint-disable max-len */
import React, {useEffect} from 'react';

import {
	PublicClientApplication,
	EventType
} from '@azure/msal-browser';
import { MsalProvider } from '@azure/msal-react';
import { msalConfig } from '../utils/auth/authConfig';

export const msalInstance = new PublicClientApplication(msalConfig);

export const AuthProvider = ({ children }) => {
	useEffect(() => {
		msalInstance.enableAccountStorageEvents();

		const callbackId = msalInstance.addEventCallback(event => {
			if (event.eventType === EventType.ACCOUNT_ADDED) {
				// Update UI with new account
				window.console.log('ACCOUNT_ADDED');
			} else if (event.eventType === EventType.ACCOUNT_REMOVED) {
				// Update UI with account logged out
				window.console.log('ACCOUNT_REMOVED');
			} else if (event.eventType === EventType.ACTIVE_ACCOUNT_CHANGED) {
				// Update UI with new active account info
				window.console.log('ACTIVE_ACCOUNT_CHANGED');
			}
		});

		return () => {
			msalInstance.disableAccountStorageEvents();
			if (callbackId) {
				msalInstance.removeEventCallback(callbackId);
			}
		};
	}, [msalInstance]); // eslint-disable-line

	return (
		<MsalProvider instance={msalInstance}>
			{children}
		</MsalProvider>
	);
};
